import React from 'react';
import './Footer.css';

class Footer extends React.Component
{
    render() {
        return(
            <footer className="footer">
                <div className="footer-inner">
                    <div>
                        <h5>Milan Marocchi</h5>
                        <p>PhD candidate, signal processing engineer, and startup founder.</p>
                    </div>
                    <nav className="footer-links" aria-label="Site links">
                        <a href="/">Home</a>
                        <a href="/About">About</a>
                        <a href="/Publications">Publications</a>
                        <a href="/GitHub">Projects</a>
                        <a href="/PodBox">PodBox</a>
                        <a href="/Archive">Archive</a>
                        <a href="/Contact">Contact</a>
                    </nav>
                    <nav className="footer-links social-links" aria-label="External links">
                        <a href="https://birdrone.com.au" target="_blank" rel="noreferrer">BIRDRONE</a>
                        <a href="https://github.com/MilanMarocchi" target="_blank" rel="noreferrer">GitHub</a>
                        <a href="https://www.linkedin.com/in/milan-marocchi-3785b1215/" target="_blank" rel="noreferrer">LinkedIn</a>
                        <a href="https://scholar.google.com/scholar?q=Milan+Marocchi" target="_blank" rel="noreferrer">Google Scholar</a>
                    </nav>
                    <div className="footer-contact">
                        <a className="email" href="mailto:milan@marcellovalentino.com">milan@marcellovalentino.com</a>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;
